export const serviceMasterHeaderElements = [
  { label: "Nombre", value: "nombre" },
  { label: "Pertenece a", value: "categoria" },
  { label: "Cotiza por", value: "unidadCotizacion" },
  { label: "Estado", value: "activo" },
];
